<template>
  <div class="navigation">
    <ul>

      <li>
        <div class="center-cont margin-botton"> 
         <!-- <img src="./engenharia.png" height="50" width="50" /> -->
         <img 
         v-if="!this.$store.getters.$GetStatusNavBar"
         src="/img/molde.gif" height="100" width="110" style="border-radius: 10px;">
        </div>
      </li>
      
        <div  v-if="this.$store.getters.$GetStatusNavBar" style="margin-bottom: 10px;"></div>
        <hr class="sidebar-divider my-0">
      
      <li v-for="link in links" :key="link.id">
        <router-link class="center-cont padding-jsb color-items-navbar" :to="link.url">
    
      
          <span class="icon"><i :class="link.icon_navigation"></i></span>
          <span  :class="['title-navbar',{ statenone: this.$store.getters.$GetStatusNavBar }]"> {{ link.title }} </span>
  
           </router-link>

     
      </li>

    </ul>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      links: [
        {
          id: 1,
          url: "/",
          icon_navigation: "fas fa-home",
          title: "Home",
        },
        {
          id: 2,
          url: "/produtos",
          icon_navigation: "fas fa-columns",
          title: "Produto",
        },
        {
          id: 3,
          url: "/moldes",
          icon_navigation: "fas fa-columns",
          title: "Molde",
        },
        {
          id: 4,
          url: "/materia-prima",
          icon_navigation: "fas fa-columns",
          title: "Materia Prima",
        },
        {
          id: 5,
          url: "/maquinas",
          icon_navigation: "fas fa-columns",
          title: "Maquinas",
        },
        {
          id: 6,
          url: "/layout-extracao",
          icon_navigation: "fas fa-columns",
          title: "Layout de Extração",
        },
           {
          id: 7,
          url: "/items-checklist",
          icon_navigation: "fas fa-columns",
          title: "Items Checklist",
        },
      ],
    };
  },
};
</script>



<style scoped>

.active a {
  color: #fff;
  background-color: transparent;
  border-radius: 0.35rem;
}

.center-cont:hover{
  background: #b4a9a9d2;
}
.title-navbar,a{
  width: 100%;
  font-weight: 700;
  text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

}

  .title-navbar{
  
    display: flex;
  
  }
.statenone{
  /* background: red; */
  display: none;
}





.margin-botton {

  margin-bottom: 35px;
}

hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.925);
    background: #fff;
}

.padding-jsb{
  justify-content: space-between;
  padding: 10px;
  margin-top: 3px;
}

.color-items-navbar{

  color: #fff;


}

.center-cont {
  display: flex;
  justify-content: center;
  align-items: center;

}

.navigation {
  position: fixed;
  width: 270px;
  height: 100vh;
  background-image: linear-gradient(#0d234e, #05c17a);
  overflow: hidden;
  transition: 0.5s;
}

.navigation.active {
  width: 60px;
}

.navigation ul {
  /* position: absolute; */
  /* top: 40px; */
  /* left: 0; */
  width: 100%;
}

.navigation ul li {
  position: relative;
  width: 100%;
  list-style: none;
}
/* 
.navigation ul li a {
  position: relative;
  display: block;
  width: 100%;
  display: flex;
  text-decoration: none;
  color: var(--white);
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.1rem;
}

.navigation ul li a .icon {
  position: relative;
  display: block;
  min-width: 60px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.navigation ul li a .icon .fas {
  color: var(--white);
  font-size: 24px;
}

.navigation ul li a .title {
  position: relative;
  display: block;
  padding: 0 10px;
  height: 80px;
  line-height: 80px;
  white-space: nowrap;
} */



@media (max-width: 650px) {
  .navigation {
    display: none;
    width: 170px;
    height: 100vh;
    background-image: linear-gradient(#0d234e, #05c17a);
    overflow: hidden;
    transition: 0.5s;
  }

  .navigation.active {
    display: block;
    width: 100%;
    margin-top: 90px;
    z-index: 9;
  }

  .padding-jsb {
    justify-content: space-between;
    /* padding: 10px; */
    /* margin-top: 3px; */
    }

  .navigation ul {
     /* position: initial; */
    /* left: 40px; */
    margin-top: 10px;
        height: 100vh;
    overflow-y: scroll;
  }

  .navigation ul li a .icon {
    position: relative;
    display: block;
    min-width: 40px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }

  .navigation ul li a .icon .fas {
    color: var(--white);
    font-size: 17px;
  }

  .navigation ul li a .title {
    position: relative;
    display: block;
    padding: 0 5px;
    height: 60px;
    line-height: 60px;
    white-space: nowrap;
  }

  /* .main {
    position: relative;
    width: calc(100% - 110px);
    height: 100vh;
    margin-left: 110px;
    transition: 0.5s;
  } */

  .main.active {
    position: relative;
    width: calc(100% - 44px);
    height: 100vh;
    margin-left: 44px;
    transition: 0.5s;
    
  }

  
.statenone{
  /* background: red; */
  display: flex;
}

}
</style>
